type PathType = 'auth' | 'login' | 'signup';

/**
 * generate a revamped auth path in format `/gift/open/[uid]/auth/
 *
 * @param pathType the type of auth path
 * @param giftUid the gift card uid
 * @param blob optional, the `b` value
 * @returns a new auth path
 */
export const generateRevampedAuthPath = (pathType: PathType, giftUid: string, blob?: string): string => {
  let newPath = `/gift/open/${giftUid}/${pathType}/`;
  if (blob) {
    newPath = `${newPath}?b=${blob}`;
  }
  return newPath;
};

type AuthMfePath = 'login' | 'register' | 'forgot-password' | 'forgot-email';

export const generateAuthMfeUrl = (path: AuthMfePath, searchParams?: Record<string, string>): URL => {
  const authMfeUrl = process.env.NEXT_PUBLIC_AUTH_MFE_URL || '';

  if (!authMfeUrl) {
    throw new Error('NEXT_PUBLIC_AUTH_MFE_URL is not defined');
  }

  return makeUrl(authMfeUrl, path, searchParams);
};

export const generateRecipientMfeUrl = (path: string, searchParams?: Record<string, string>): URL => {
  const recipientMfeUrl = process.env.NEXT_PUBLIC_RECIPIENT_MFE_URL || '';

  if (!recipientMfeUrl) {
    throw new Error('NEXT_PUBLIC_RECIPIENT_MFE_URL is not defined');
  }
  return makeUrl(recipientMfeUrl, path, searchParams);
};

type CustomerMfePath = 'wallet' | 'orders' | 'details';

export const generateCustomerMfeUrl = (path: CustomerMfePath, searchParams?: Record<string, string>): URL => {
  const customerMfeUrl = process.env.NEXT_PUBLIC_CUSTOMER_MFE_URL || '';

  if (!customerMfeUrl) {
    throw new Error('NEXT_PUBLIC_CUSTOMER_MFE_URL is not defined');
  }
  return makeUrl(customerMfeUrl, path, searchParams);
};

const makeUrl = (baseUrl: string, path: string, searchParams?: Record<string, string>): URL => {
  let url = new URL(`${baseUrl}/${path}`);
  if (searchParams) {
    Object.entries(searchParams).forEach(entry => {
      url.searchParams.append(entry[0], entry[1]);
    });
  }
  return url;
};
